import _regeneratorRuntime from '/app/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/app/node_modules/babel-runtime/helpers/asyncToGenerator';
import Vue from 'vue';
import Vuex from 'vuex';
import axios from '../plugins/axios';

Vue.use(Vuex);

var store = function store() {
	return new Vuex.Store({
		state: {
			settings: {
				lang: '',
				homeTitle: '',
				globalNav: [],
				phone: '',
				phoneLink: '',
				email: '',
				social: []
			}
		},

		mutations: {
			'settings->set': function settingsSet(state, settings) {
				state.settings = settings;
			}
		},

		actions: {
			nuxtServerInit: function () {
				var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref, _ref2) {
					var commit = _ref.commit;
					var req = _ref2.req;
					var host, query, lang, ignore_suffix, url, urlpathh, settings, i;
					return _regeneratorRuntime.wrap(function _callee$(_context) {
						while (1) {
							switch (_context.prev = _context.next) {
								case 0:
									host = req.headers.host;
									query = req.url.split('/').slice(1);
									lang = 'ru';

									if (query[0] == 'eng') {
										lang = 'en';
									}
									ignore_suffix = ['about', 'catalog'];
									_context.prev = 5;
									url = req.url.replace('/', '');
									urlpathh = 'settings/' + lang;
									_context.next = 10;
									return axios.get(urlpathh);

								case 10:
									settings = _context.sent.data;

									//settings.url = url;
									//settings.query = query;
									settings.urlpathh = urlpathh;
									settings.query = query;
									_context.t0 = _regeneratorRuntime.keys(settings.domains);

								case 14:
									if ((_context.t1 = _context.t0()).done) {
										_context.next = 24;
										break;
									}

									i = _context.t1.value;

									if (!(settings.domains[i].host == host && ignore_suffix.indexOf(url) == -1)) {
										_context.next = 21;
										break;
									}

									settings._head.title = settings.domains[i].title_suffix;
									return _context.abrupt('break', 24);

								case 21:
									settings._head.title = host;

								case 22:
									_context.next = 14;
									break;

								case 24:
									commit('settings->set', settings);
									_context.next = 30;
									break;

								case 27:
									_context.prev = 27;
									_context.t2 = _context['catch'](5);

									console.log(_context.t2);

								case 30:
								case 'end':
									return _context.stop();
							}
						}
					}, _callee, this, [[5, 27]]);
				}));

				function nuxtServerInit(_x, _x2) {
					return _ref3.apply(this, arguments);
				}

				return nuxtServerInit;
			}()
		}
	});
};

export default store;


//////////////////
// WEBPACK FOOTER
// ./store/index.js
// module id = ./store/index.js
// module chunks = 5